// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brandsDesktop_7I44E{color:var(--cp-black);display:flex;flex-direction:column;flex-grow:1;font-weight:400;padding:16px;position:relative}@media only screen and (min-width:600px){.brandsDesktop_7I44E{display:flex;flex-direction:row;flex-wrap:nowrap;max-height:none;padding:0}}@media only screen and (min-width:1264px){.v-application .container.brandsDesktop_7I44E{padding:0 2.4rem}}@media only screen and (min-width:1600px){.v-application .container.brandsDesktop_7I44E{margin:0 auto;max-width:1680px;padding:0 4.5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brandsDesktop": "brandsDesktop_7I44E"
};
module.exports = ___CSS_LOADER_EXPORT___;
